export default () => "web";
